module.exports = __webpack_public_path__ + "media/fonts/BrandonGrotesque-Medium-0500ce5b09a764ddea1e0969cc1b6402.woff2";